import { Component, Input, inject, OnInit, viewChild, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { QuillModule } from 'ngx-quill';
import { finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { CatalogItemService } from 'src/app/services/catalog-item.service';
import { LoadingService } from 'src/app/services/loading.service';
import { DuplicateCatalogVersion, DuplicateCatalogVersionResult, GetCatalogItemVersion } from 'src/app/models/catalogs/catalog';
import { ModalCatalogWizardComponent } from '../modal-catalog-wizard/modal-catalog-wizard.component';
import { environment } from 'src/environments/environment';
import { ImagePreviewComponent } from "src/app/components/shared/image-preview/image-preview.component";
import { quillModules } from '../modal-catalog-wizard/basic-info-step/basic-info-step.component';

@Component({
  selector: 'app-modal-duplicate-catalog-version',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, QuillModule, ModalCatalogWizardComponent, ImagePreviewComponent],
  templateUrl: './modal-duplicate-catalog-version.component.html',
  styleUrls: ['./modal-duplicate-catalog-version.component.css']
})
export class ModalDuplicateCatalogVersionComponent implements OnInit {
  changeData = output<void>();

  catalogItemId!: number;
  sourceVersionId!: number;

  currentVersion?: GetCatalogItemVersion;

  private fb = inject(FormBuilder);
  private catalogSvc = inject(CatalogItemService);
  private loadingSvc = inject(LoadingService);

  form: FormGroup = this.fb.group({
    title: ['', [Validators.required, Validators.maxLength(200)]],
    subtitle: ['', [Validators.required, Validators.maxLength(300)]],
    shortDescription: ['', [Validators.required, Validators.maxLength(600)]],
    longDescription: [''],
    publishNow: [false]
  });

  fileBaseUrl = `${environment.api.url}/File/ViewFile`;

  modalCatalogWizardComponent = viewChild(ModalCatalogWizardComponent);

  quillOptions = quillModules;
  ngOnInit() {

  }

  open(catalogItemId: number, sourceVersionId: number) {
    this.catalogItemId = catalogItemId;
    this.sourceVersionId = sourceVersionId;

    this.currentVersion = undefined;
    this.form.reset({
      title: '',
      subtitle: '',
      shortDescription: '',
      longDescription: '',
      publishNow: false
    });

    this.loadingSvc.show();
    this.catalogSvc.getCatalogItemVersionById(sourceVersionId)
      .pipe(
        finalize(() => this.loadingSvc.hide())
      )
      .subscribe({
        next: (v: GetCatalogItemVersion) => {
          this.currentVersion = v;
          this.form.patchValue({
            title: v.title,
            subtitle: v.subtitle,
            shortDescription: v.shortDescription,
            longDescription: v.longDescription
          })
          const modal = new (window as any).bootstrap.Modal(
            document.getElementById('modalDuplicateCatalogVersion'),
            {}
          );
          modal.show();
        }, error: (error) => Swal.fire('Error', error[0] ?? 'Error al obtener los datos', 'error')
      });
  }


  close() {
    const el = document.getElementById('modalDuplicateCatalogVersion');
    if (!el) return;
    const modal = (window as any).bootstrap.Modal.getInstance(el);
    modal?.hide();
  }

  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const payload: DuplicateCatalogVersion = {
      catalogItemId: this.catalogItemId,
      sourceVersionId: this.sourceVersionId,
      ...this.form.value
    };

    this.loadingSvc.show();

    this.catalogSvc.duplicateCatalogVersion(payload)
      .pipe(finalize(() => this.loadingSvc.hide()))
      .subscribe({
        next: (res: DuplicateCatalogVersionResult) => {
          Swal.fire({
            icon: 'success',
            title: 'Catálogo duplicado',
            text: `Versión ${res.versionNumber} creada correctamente`
          });
          this.close();
          this.changeData.emit();
        },
        error: (error) => {
          Swal.fire('Error', error[0] ?? 'No se pudo duplicar el catálogo', 'error');
        }
      });
  }

  viewVersion(v: GetCatalogItemVersion) {
    const modalWizard = this.modalCatalogWizardComponent?.();
    modalWizard?.openForView(v.id);
  }
}